/**
 * VRActor - base class for VR actors that can be attached to VR hands. Extends Actor with
 * VR-specific functionality for hand attachment and input handling.
 */

import { Actor } from '../actors/Actor.js';
import { EngineClass } from '../systems/ClassRegistry.js';

import type { ActorOptions } from '../actors/Actor.js';
import type * as THREE from 'three';

/** Options for VRActor */
export interface VRActorOptions extends ActorOptions {
  // Placeholder for the future
}

@EngineClass('VRActor')
export class VRActor extends Actor {


  /** Called when the VR pawn's target ray starts hovering this actor */
  public onVRHoverStart?(hand: 'left' | 'right', point: THREE.Vector3): void;

  /** Called each frame while the VR pawn's target ray is hovering this actor */
  public onVRHover?(hand: 'left' | 'right', point: THREE.Vector3): void;

  /** Called when the VR pawn's target ray stops hovering this actor */
  public onVRHoverEnd?(hand: 'left' | 'right'): void;
}
